// English — canonical. Other locales fall back here when a key is missing.
export const en = {
  'nav.skipContent': 'Skip to page content',
  'nav.solutions': 'Live solutions',
  'nav.streamTemplates': 'Stream templates',
  // Brand / common
  'app.name':           'Kardolive',
  'app.tagline':        'Customer portal',
  'app.signOut':        'Sign out',

  // Login / signup
  'login.email':        'Email',
  'login.password':     'Password',
  'login.signIn':       'Sign in',
  'login.signingIn':    'Signing in…',
  'login.failed':       'Login failed',
  'login.newAccount':   'New to Kardolive?',
  'login.createAccount':'Create a free account →',

  // Layout / sidebar sections
  'nav.workspace':      'Workspace',
  'nav.prepare':        'Prepare',
  'nav.events':         'Events & live streams',
  'nav.featurePresets': 'Feature presets',
  'nav.interact':       'Interact',
  'nav.boards':         'Interactive boards',
  'nav.measure':        'Reports & commerce',
  'nav.menu':           'Open navigation',
  'nav.closeMenu':      'Close navigation',
  'nav.templates':      'Templates',
  'nav.live':           'Live',
  'nav.rooms':          'Rooms & chat',
  'nav.content':        'Content',
  'nav.developer':      'Developer',
  'nav.account':        'Account',

  // Sidebar items
  'nav.overview':       'Overview',
  'nav.streams':        'Live Stream',
  'nav.blueprints':     'Blueprints',
  'nav.studio':         'Studio',
  'nav.projects':       'Projects',
  'nav.chat':           'Chat console',
  'nav.sessions':       'Sessions',
  'nav.scenarios':      'Scenarios',
  'nav.recordings':     'Recordings',
  'nav.verticals':      'Verticals',
  'nav.platform':       'Platform',
  'nav.restream':       'Restream destinations',
  'nav.premieres':      'Premieres',
  'nav.clips':          'Clips',
  'nav.catalog':        'Catalog',
  'nav.apiKeys':        'API keys',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook tester',
  'nav.networkTest':    'Network test',
  'nav.embed':          'Embed widgets',
  'nav.sdk':            'SDKs & docs',
  'nav.docs':           'Developer docs',
  'nav.analytics':      'Analytics',
  'nav.settings':       'Settings',

  // Overview / dashboard
  'overview.welcome':       'Welcome back, {name}',
  'overview.plan':          '{tenant} · {plan} plan',
  'overview.newStream':     'New stream',
  'overview.kpi.live':           'Live now',
  'overview.kpi.live.broadcasting': 'streams broadcasting',
  'overview.kpi.live.nothing':    'nothing live',
  'overview.kpi.total':           'Total streams',
  'overview.kpi.total.sub':       'across all time',
  'overview.kpi.sessions':        'Sessions · 30 days',
  'overview.kpi.sessions.sub':    'publish events',
  'overview.kpi.recordings':      'Recordings',
  'overview.kpi.recordings.sub':  'ready to play',
  'overview.recentStreams':       'Recent streams',
  'overview.recentSessions':      'Recent sessions',
  'overview.viewAll':             'View all →',
  'overview.empty.title':         'No streams yet',
  'overview.empty.body':          'Create your first stream to start broadcasting.',
  'overview.empty.action':        'Create stream',
  'overview.noSessions':          'No sessions yet',

  // Status badges
  'status.live':        'LIVE',
  'status.idle':        'IDLE',
  'status.ended':       'ENDED',
  'status.archived':    'ARCHIVED',

  // Common buttons
  'common.save':        'Save',
  'common.cancel':      'Cancel',
  'common.delete':      'Delete',
  'common.edit':        'Edit',
  'common.create':      'Create',
  'common.confirm':     'Confirm',
  'common.loading':     'Loading…',
  'common.error':       'Error',
  'common.retry':       'Retry',
  "dashboard.stale": "Could not refresh. Showing the last loaded information.",
  "dashboard.loadFailed": "Could not load this section. Please try again.",
  "dashboard.overviewIntro": "Your live streams and next steps, in one place.",
  "dashboard.liveNow": "Live now",
  "dashboard.upNext": "Up next",
  "dashboard.continue": "Continue working",
  "dashboard.openBroadcast": "Open broadcast controls",
  "dashboard.openStream": "Open stream",
  "dashboard.scheduled": "Scheduled",
  "dashboard.schedule": "Schedule a stream",
  "dashboard.manualStart": "These are planned start times. You still press Go live to start.",
  "dashboard.noSchedule": "No upcoming streams. Add a date when creating your next stream.",
  "dashboard.noRecent": "Your other streams will appear here.",
  "dashboard.summary": "Workspace summary",
  "dashboard.analytics": "View analytics",
  "dashboard.minutes": "Minutes streamed",
  "dashboard.last30": "Last 30 days",
  "dashboard.quickStart": "Getting started? See the next steps",
  "dashboard.prepareCamera": "Check your camera and prepare to go live",
  "dashboard.recordingHint": "If recording is enabled, check its status after your broadcast in",
  "dashboard.dismiss": "Hide this guide",
  "dashboard.recordingsIntro": "Your recorded broadcasts. Play ready videos and check recording status here.",
  "dashboard.account": "Account",
  "dashboard.language": "Language",
  "dashboard.appearance": "Appearance",
  "dashboard.close": "Close",
  "nav.allStreams": "All streams",
  "nav.destinations": "Destinations",
  "nav.ecommerce": "Ecommerce",
  "nav.products": "Products",
  "nav.services": "Services",
  "nav.collections": "Collections",
  "nav.orders": "Orders",
  "nav.commerceSettings": "Commerce settings",
  "nav.engagement": "Engagement",

  // Dashboard navigation and account controls.
  "theme.light": "Switch to light mode",
  "theme.dark": "Switch to dark mode",
  "role.owner": "Owner",
  "role.admin": "Administrator",
  "role.member": "Member",
  "role.viewer": "Viewer",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Active",
  "streams.archived": "Archived",
  "streams.monitor": "Feed monitor",
  "streams.create": "Create live stream",
  "streams.list": "List",
  "streams.grid": "Grid",
  "streams.view": "Stream view",
  "streams.searchLabel": "Search events",
  "streams.searchHint": "Search event names",
  "streams.solutionFilter": "Filter events by solution",
  "streams.statusFilter": "Filter events by status",
  "streams.dateFilter": "Filter events by creation date",
  "streams.allSolutions": "All solutions",
  "streams.custom": "Existing / custom setup",
  "streams.allStatuses": "All statuses",
  "streams.anyTime": "Created any time",
  "streams.last7": "Created last 7 days",
  "streams.last30": "Created last 30 days",
  "streams.count": "Showing {shown} of {total} events",
  "streams.noMatch": "No events match your filters.",
  "streams.clearFilters": "Clear filters",
  "streams.refreshFailed": "Your stream list could not refresh",
  "streams.loadFailed": "Could not load your streams",
  "streams.stale": "Showing the last loaded streams. Their status may have changed.",
  "streams.connectionHint": "Check your connection and try loading the list again.",
  "streams.retrying": "Retrying…",
  "streams.retry": "Try again",
  "streams.restoreFailed": "Could not restore the stream",
  "streams.restoreHint": "Check your connection and refresh the list to check the latest status before trying again.",
  "streams.unused": "Unused streams: {count}",
  "streams.unusedHint": "No broadcasts or replays. Archive these streams to tidy your list; nothing is deleted.",
  "streams.reviewArchive": "Review and archive",
  "streams.loading": "Loading your streams…",
  "streams.archiveEmpty": "Nothing archived. Archived streams and their replays stay here until you restore them.",
  "streams.restore": "Restore",
  "streams.firstTitle": "Create your first stream",
  "streams.firstBody": "Choose a setup for a sale, class or service, or start with a blank stream. Broadcast from your browser, phone or OBS.",
  "streams.blank": "Blank stream",
  "streams.broadcasts": "Broadcasts: {count}",
  "streams.replays": "Replays: {count}",
  "streams.sessions": "Sessions: {count}",
  "streams.recordings": "Recordings: {count}",
  "streams.mode.BROADCAST": "Broadcast",
  "streams.mode.LOW_LATENCY": "Low latency",
  "streams.mode.REALTIME": "Real-time",
  "streams.key": "Key",
  "streams.archiveTitle": "Archive unused streams",
  "streams.archiveHint": "These streams have never broadcast. You can restore them from the Archived tab at any time.",
  "streams.archiveFailed": "Could not archive {count} streams; they may have gone live. The others were archived.",
  "streams.archiving": "Archiving…",
  "streams.archiveCount": "Archive {count}",
  "streamType.webinar": "Business webinars & launches",
  "streamType.classroom": "Classrooms & tutoring",
  "streamType.training": "Corporate training",
  "streamType.conference": "Conferences & exhibitions",
  "streamType.shopping": "Live shopping",
  "streamType.auction": "Live auctions",
  "streamType.consultation": "Private consultations",
  "streamType.creator": "Creator & community live",
  "streamType.audio": "Audio rooms & podcasts",
  "streamType.sports": "Sports & esports",
  "streamType.performance": "Concerts & performances",
  "streamType.community": "Worship & fundraising",
  "streamType.tour": "Tours & demonstrations",
  "streamType.fitness": "Fitness & workshops",
  "streamType.public-meeting": "News & public meetings",
  "streamType.continuous": "Continuous channels & cameras",
  "streams.close": "Close",
};
